export const setChatOpenAction = (state,action) =>{ 
	state.ischat = action.payload;
}
export const setMainLoadingAction = (state,action) =>{ 
	state.isMainLoading = action.payload;
}
export const setInitialLoaderAction = (state,action) =>{ 
	state.initialLoader = action.payload;
}
export const setErrorBoundryAction = (state,action) =>{
	state.errorBoundry = action.payload;
	state.initialLoader = false;
}
export const setPageTitleAction = (state,action) =>{
	state.pageTitle = action.payload;
}
export const toggleSideNavAction = (state,action) =>{
	state.sideBarOpen = !state.sideBarOpen;
}
export const OpenModalAction = (state) =>{
	state.modalOpen = true;
}
export const closeModalAction = (state) =>{
	state.modalOpen = false;
}
export const setSearchKeywordAction = (state,action) =>{
	state.searchKeyword = action.payload;
}

export const setSupplierSearchKeywordAction = (state,action) =>{
	state.supplierSearchKeyword = {...state.supplierSearchKeyword,...action.payload};
}